import RestCreate from 'containers/rest/Create';
import FormCreate from '../components/Form/Create';
import { useEffect, useState } from 'react';
import { getPaymentMethodApi } from 'api/payments';
import { omit } from 'lodash';

const breadcrumbs = [
   {
     title: 'common.page.ordersReturn',
     href: '/orders-return',
   },
    {
       title: 'common.page.create',
    },
 ];

export default function Create() {
   const [payments, setPayments] = useState([]);

   useEffect(() => {
      const getPayments = async () => {
         const { data } = await getPaymentMethodApi();
         if(Array.isArray(data) && data.length > 0) {
            setPayments(data);
         }
      }
      getPayments();
   },[])

   return (
      <RestCreate
         model="ordersReturn"
         breadcrumbs={breadcrumbs}
         customPathAfterSubmit="orders-return"
         customUrlBack='/orders-return'
         hasSelectFilter={false}
         // formatOnSubmit={(_values) => console.log('1231xcc32', _values)}
         // customSubmit={handleCheckSubmit}
         formatOnSubmit={(values) => {
            return {
               ...omit(values, ['paymentType']),
               refundPaymentMethodId: payments?.find((item) => item?.name === values?.paymentType)?.id,
            }
         }}
      >
         <FormCreate />
      </RestCreate>
   )
} 